import React, { createContext, useState } from 'react';
import type{ Dispatch, SetStateAction} from 'react';
export type DataContextType<T> = {
  data: T | null;
  updateData: Dispatch<SetStateAction<T | null>>;
};

type DataProviderProps<T> = {
  children: React.ReactNode;
  initialData?: DataContextType<T>['data'];
};

// Create context with proper generic type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DataContext = createContext<DataContextType<any>>({
  data: null,
  updateData: () => {},
});

const DataProvider = <I,>({ children, initialData = null }: DataProviderProps<I>) => {
 const [data, setData] = useState<I | null>(initialData);

  return (
    <DataContext.Provider value={{ data, updateData: setData }}>
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };